import React from 'react';
import { createBrowserRouter } from 'react-router-dom';
import { AuthenticatedTemplate } from '@azure/msal-react';
import Root from '../routes/root';
import ErrorPage from '../error-page';
import Index from '../routes/index';
import { IdTokenData } from '../components/my-claims';

// Import feature route configurations
import { scheduleRoutes } from './routes/schedule.routes';
import { payablesRoutes } from './routes/payables.routes';
import { settingsRoutes } from './routes/settings.routes';
import { certificationRoutes } from './routes/certification.routes';
import { navigationRoutes } from './routes/navigation.routes';
import { reportsRoutes } from './routes/reports.routes';

/**
 * Creates the application router with all route configurations
 * @param {Object} idTokenClaims - User's ID token claims for the claims page
 */
export function createAppRouter(idTokenClaims) {
  return createBrowserRouter([
    {
      path: '/',
      element: <Root />,
      errorElement: <ErrorPage />,
      children: [
        {
          errorElement: <ErrorPage />,
          children: [
            // Home route
            {
              index: true,
              element: (
                <AuthenticatedTemplate>
                  <Index />
                </AuthenticatedTemplate>
              ),
            },
            // Claims/debugging route
            {
              path: '/claims',
              element: (
                <AuthenticatedTemplate>
                  <IdTokenData idTokenClaims={idTokenClaims} />
                </AuthenticatedTemplate>
              ),
            },
            // Feature routes
            ...scheduleRoutes,
            ...certificationRoutes,
            ...settingsRoutes,
            ...payablesRoutes,
            ...navigationRoutes,
            ...reportsRoutes,
          ],
        },
      ],
    },
  ], {
    basename: import.meta.env.VITE_VIRTUAL_DIRECTORY || '/',
  });
}

export default createAppRouter;

